export const CHANGE_HEADER_CONTENT = "CHANGE_HEADER_CONTENT";